exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".artilleryFirelist[data-v-9ae7f63c] {\n  margin: 0.625rem 1.25rem;\n}", ""]);

// exports
